import { Text } from "@mantine/core"
import { openConfirmModal } from "@mantine/modals"
import { useEffect } from "react"
import { useBlocker } from "react-router-dom"

type UseUnsavedChangesBlockerProps = {
  isDirtyCallback: () => boolean
  onConfirmCallback?: () => void
  shouldBlockNavigation?: (args: {
    currentLocation: string
    nextLocation: string
    isDirtyCallback: () => boolean
  }) => boolean
}

export function useUnsavedChangesBlocker({
  isDirtyCallback,
  onConfirmCallback,
  shouldBlockNavigation,
}: UseUnsavedChangesBlockerProps) {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (shouldBlockNavigation) {
      return shouldBlockNavigation({
        currentLocation: currentLocation.pathname,
        nextLocation: nextLocation.pathname,
        isDirtyCallback,
      })
    }
    if (currentLocation.pathname === nextLocation.pathname) {
      return false
    }
    return isDirtyCallback()
  })

  useEffect(() => {
    if (blocker.state === "blocked") {
      openConfirmModal({
        title: "You have unsaved changes",
        children: <Text>Are you sure you want to leave?</Text>,
        onClose: blocker.reset,
        onConfirm: () => {
          blocker.proceed()
          onConfirmCallback?.()
        },
        labels: {
          cancel: "Stay",
          confirm: "Leave",
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocker.state])
}
